define([
	"dojo/_base/declare",
	"csi/widget/CustomIconWithLabel",
	"Calendar/CompletionRenderer"
], function(declare,CustomIconWithLabel,CompletionRenderer) {

	return declare(CompletionRenderer, {
		reserveContext: function(/*csi.def.Context*/ctx, /*csi.def.Heading*/h) {
			// summary: render completion date in calendar activity table
			var cal = ctx.view.getViewNode();

			// handle special case where context is milestone activity
			if (cal.$Type == "Milestone") {
				cal = ctx.cache.getNode(cal.__Parent__);
			}

			var actMaster = ctx.getNode();

			//[YG] ctx could been affected by action controller, so then let us use keyValue.
			if (actMaster.$Type != "MasterActivity") {
				actMaster = this._getMasterActivity(ctx, cal);
			}

			this._reserveContext(ctx, cal, actMaster, true);
			this.inherited(arguments);
		},

		/**
		 * @override
		 * Display completion date or completeness
		 */
		toHtmlStatic(ctx, h, refNode, actionData) {
			const value = this.toValue(ctx, h);

			if (value) {
				const stateIndex = this._getStateIndex(ctx);

				if (stateIndex === 2) {  // "CompleteLate" state
					new CustomIconWithLabel({
						icon: "completelate",
						label: value
					}).placeAt(refNode);

					return true;
				}
			}

			return this.inherited(arguments);
		}
	});
});